export default __webpack_public_path__ + "static/CompleteStreets-300915c202c4758fdb9e7f05da354ddf.jpg";